import React, { useRef } from "react";
import Autocomplete from "react-google-autocomplete";

const GooglePlacesMulti2 = ({ index, setAcademyData, fieldNames, value }) => {
  const handleError = (error) => {
    console.error("Error selecting place:", error);
  };
  const autocompleteRef = useRef(null);

  const handleInputBlur = () => {
    if (autocompleteRef.current && !autocompleteRef.current.value) {
      const emptyFields = {};
      fieldNames.forEach((name) => {
        emptyFields[name] = "";
      });
      setAcademyData((prev) => {
        const newForms = [...prev];
        newForms[index] = { ...newForms[index], ...emptyFields };
        return newForms;
      });
    }
  };

  return (
    <Autocomplete
      ref={autocompleteRef}
      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      className="form-control"
      defaultValue={value}
      onPlaceSelected={(place) => {
        const location = place?.formatted_address;
        const lat = place?.geometry?.location.lat();
        const lng = place?.geometry?.location.lng();

        const updatedFields = {
          [fieldNames[0]]: location,
          [fieldNames[1]]: lat,
          [fieldNames[2]]: lng,
        };

        setAcademyData((prev) => {
          const newForms = [...prev];
          newForms[index] = { ...newForms[index], ...updatedFields };
          return newForms;
        });
      }}
      onBlur={handleInputBlur}
      onError={handleError}
    />
  );
};

export default GooglePlacesMulti2;
